import { combineReducers } from 'redux';

import sessionReducer from './sessionReducer';
import notifierReducer from './notifierReducer';
import usersReducer from '../views/Management/reducers/UsersReducer';
import operatorsReducer from '../views/Management/reducers/OperatorsReducer';
import settingsReducer from '../views/Management/reducers/SettingsReducer';
import dashboardInspectReducer from '../views/Dashboard/reducers/DashboardInspectReducer';
import mapReducer from '../components/Map/reducers/MapReducer';
import shutdown3gReducer from '../views/Shutdown3g/reducers/Shutdown3gReducer';
import emailsReducer from '../views/EmailsWrongRight/reducers/emailReducer';
import tefInternalReducer from '../views/TefInternal/Reducers/TefInternalReducer';
import oldOutagesReducer from '../views/OldOutages/Reducers/OldOutagesReducer';
import backOnAirReducer from '../views/BackOnAir/Reducers/BackOnAirReducer';
import helixCrqsReducer from '../views/HelixCrqs/Reducers/HelixCrqsReducer';

const rootReducer = combineReducers({
	session: sessionReducer,
	usersReducer,
	notifierReducer,
	operatorsReducer,
	settingsReducer,
	dashboardInspectReducer,
	mapReducer,
	shutdown3gReducer,
	emailsReducer,
	tefInternalReducer,
	oldOutagesReducer,
	backOnAirReducer,
	helixCrqsReducer
});

export default rootReducer;
